import { SubmitButton } from "components";
import CsvTable from "./CsvTable";
import { MouseEventHandler, useState } from "react";
import { bulkRegistrationProp } from "../../store/ActionType";

interface PreviewCSVProps {
  csvData: bulkRegistrationProp[];
  handleSubmit: MouseEventHandler<HTMLButtonElement> | undefined;
  isSubmitting:boolean;
  progress:number;
  fileName: string;
  csvError: string;
}

const PreviewCSV: React.FC<PreviewCSVProps> = ({
  csvData,
  fileName,
  csvError,
  isSubmitting,
  handleSubmit,
  progress
}) => {
  

  return (
    <div className="w-full p-6 flex gap-2 border rounded-md shadow-sm bg-primary-300/10">
      {/* File Info & Error Message */}
      <div className="w-2/5 flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
        <div>
          {fileName && (
            <div className="pb-6">
              <div className="text-lg text-gray-700 pb-2">
                <p>Selected file:</p>
                <strong>{fileName}</strong>
              </div>
              <p className="text-sm text-gray-700">
                Total records: <strong>{csvData.length}</strong>
              </p>
            </div>
          )}
          <p className="text-sm text-orange-500">
            note: Please check the <strong>CSV</strong> data before submitting.
            Once submitted, the data cannot be modified and will be added to the
            database directly.
          </p>

          <div className="relative mt-4 sm:mt-2">
            <SubmitButton onClick={handleSubmit} disabled={isSubmitting} />

            {isSubmitting && (
              <div className="relative mt-2 w-full">
                <div className="w-full h-4 bg-primary-300 rounded overflow-hidden">
                  <div
                    className="bg-primary-500 h-full text-xs text-white text-center transition-all duration-200"
                    style={{ width: `${progress}%` }}
                  >
                    {progress}%
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {csvError && (
          <div className="p-4 border border-red-300 bg-red-50 text-red-700 rounded w-full sm:w-auto">
            <p>
              <strong>Error:</strong> {csvError}
            </p>
          </div>
        )}
      </div>
      {/* CSV Data Table */}
      <div className="w-3/5">
        <CsvTable csvData={csvData} fileName={fileName} />
      </div>
    </div>
  );
};

export default PreviewCSV;
